import React from 'react';
import * as S from '../RoomTypeLoader/RoomTypeLoader.styles';

const RoomTypeLoader = () => (
  <S.RoomTypeLoaderWrapDiv>
    <S.RoomTypeLoaderHeaderWrapDiv>
      <S.RoomTypeLoaderHeaderDiv>Room Type</S.RoomTypeLoaderHeaderDiv>
      <S.RoomTypeLoaderHeaderDiv>Room Options</S.RoomTypeLoaderHeaderDiv>
      <S.RoomTypeLoaderHeaderDiv>Inclusions</S.RoomTypeLoaderHeaderDiv>
      <S.RoomTypeLoaderHeaderDiv>Price</S.RoomTypeLoaderHeaderDiv>
    </S.RoomTypeLoaderHeaderWrapDiv>
    <S.RoomTypeLoaderContentWrapDiv>
      <S.RoomTypeLoaderContentLeftDiv>
        <S.RoomTypeLoaderTypeTextDiv></S.RoomTypeLoaderTypeTextDiv>
        <S.RoomTypeLoaderImgDiv></S.RoomTypeLoaderImgDiv>
        <S.RoomTypeLoaderTypeTextDiv></S.RoomTypeLoaderTypeTextDiv>
        <S.RoomTypeLoaderTypeTextDiv></S.RoomTypeLoaderTypeTextDiv>
        <S.RoomTypeLoaderTypeTextDiv></S.RoomTypeLoaderTypeTextDiv>
        <S.RoomTypeLoaderDescpDiv></S.RoomTypeLoaderDescpDiv>
      </S.RoomTypeLoaderContentLeftDiv>
      <S.RoomTypeLoaderContentRightDiv>
        <S.RoomTypeLoaderOptionsDiv>
          <S.RoomTypeLoaderOptionsTextDiv></S.RoomTypeLoaderOptionsTextDiv>
          <S.RoomTypeLoaderOptionsTextDiv></S.RoomTypeLoaderOptionsTextDiv>
          <S.RoomTypeLoaderOptionsTextLargeDiv></S.RoomTypeLoaderOptionsTextLargeDiv>
          <S.RoomTypeLoaderOptionsTextDiv></S.RoomTypeLoaderOptionsTextDiv>
        </S.RoomTypeLoaderOptionsDiv>
        <S.RoomTypeLoaderInclusionsDiv>
          <S.RoomTypeLoaderInclusionsTextDiv></S.RoomTypeLoaderInclusionsTextDiv>
          <S.RoomTypeLoaderInclusionsTextDiv></S.RoomTypeLoaderInclusionsTextDiv>
        </S.RoomTypeLoaderInclusionsDiv>
        <S.RoomTypeLoaderPriceDiv>
          <S.RoomTypeLoaderPricesTextDiv></S.RoomTypeLoaderPricesTextDiv>
          <S.RoomTypeLoaderPricesSmallTextDiv></S.RoomTypeLoaderPricesSmallTextDiv>
          <S.RoomTypeLoaderPriceLargeTextDiv></S.RoomTypeLoaderPriceLargeTextDiv>
          <S.RoomTypeLoaderPricesSmallTextDiv></S.RoomTypeLoaderPricesSmallTextDiv>
          <S.RoomTypeLoaderPriceDescpDiv></S.RoomTypeLoaderPriceDescpDiv>
          <S.RoomTypeLoaderPricesSmallerTextDiv></S.RoomTypeLoaderPricesSmallerTextDiv>
        </S.RoomTypeLoaderPriceDiv>
      </S.RoomTypeLoaderContentRightDiv>
    </S.RoomTypeLoaderContentWrapDiv>
  </S.RoomTypeLoaderWrapDiv>
);

export default RoomTypeLoader;
